import { ValoriFiltroArchivi, Archivio, FiltroArchivi, UrlArchivio } from './models';
import { query } from '../api';
import { ApplicationState } from '..';
import { PageResult } from '../core';

export const getFiltroArchivi = (
    state: ApplicationState,
    refreshCache: boolean
): Promise<ValoriFiltroArchivi> => {
    const url: string = 'api/archivi/valoriFiltro';
    const requestCache: RequestCache = refreshCache ? "reload" : "default";

    return query<ValoriFiltroArchivi>(url, state, {}, requestCache);
}

export const getArchivi = (
    state: ApplicationState,
    filtro: FiltroArchivi,
    refreshCache: boolean
): Promise<PageResult<Archivio>> => {
    const url = 'api/archivi';
    const requestCache: RequestCache = refreshCache ? "reload" : "default";

    return query<PageResult<Archivio>>(url, state, filtro, requestCache);
}

export const getUrlArchivio = (
    state: ApplicationState,
    idArchivio: string
): Promise<UrlArchivio> => {
    const url = 'api/archivi/urlarchivio';
    const data = { idArchivio };

    return query<UrlArchivio>(url, state, data, 'default');
}